/* LAB PROFILE */
export const GET_STAFF_PROFILE = "GET_STAFF_PROFILE";
export const GET_STAFF_PROFILE_SUCCESS = "GET_STAFF_PROFILE_SUCCESS";
export const GET_STAFF_PROFILE_FAIL = "GET_STAFF_PROFILE_FAIL";

export const UPDATE_STAFF_PROFILE = "UPDATE_STAFF_PROFILE";
export const UPDATE_STAFF_PROFILE_SUCCESS = "UPDATE_STAFF_PROFILE_SUCCESS";
export const UPDATE_STAFF_PROFILE_FAIL = "UPDATE_STAFF_PROFILE_FAIL";
